import React from 'react'
import PropTypes from 'prop-types'
import styles from './styles.module.css'

export default function UsageBadge({ stats = {} }) {
  const { savedSearchCount = 0, savedSearchLimit, savedSearchLimitTier } = stats
  const limitLabel =
    savedSearchLimitTier === null || savedSearchLimitTier === undefined
      ? 'unlimited'
      : savedSearchLimit

  return (
    <span className={styles.usageBadge}>
      <span className={styles.usageBadgeCount}>{savedSearchCount}</span>
      {` of ${limitLabel} saved searches used`}
    </span>
  )
}

UsageBadge.propTypes = {
  stats: PropTypes.shape({
    savedSearchCount: PropTypes.number,
    savedSearchLimit: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    savedSearchLimitTier: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]),
  }),
}
